import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Collapse } from '../../components/Collapse';
import { Portal } from '../../components/Portal';
import { Text } from '../Text';
import { StyledDropdownContainer, StyledDropdownOptionWrapper, StyledDropdownOptionsContainer, StyledDropdownWrapper, } from './Dropdown.style';
export function Dropdown({ dimensions, children, options, opened = false, onSelect, }) {
    const [isOpened, setIsOpened] = useState(false);
    const handleSelect = (selectedValue, selectedIndex) => {
        setIsOpened(false);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedValue, selectedIndex);
    };
    useEffect(() => {
        setIsOpened(opened);
    }, [opened]);
    return (_jsx(Portal, { children: _jsx(StyledDropdownContainer, { className: "dropdown-container", style: {
                top: dimensions.top,
                left: dimensions.left,
                width: dimensions.width,
            }, children: _jsx(Collapse, { isOpened: isOpened, children: _jsx(StyledDropdownWrapper, { children: _jsx(StyledDropdownOptionsContainer, { children: options
                            ? options.map((option, index) => {
                                return (_jsx(StyledDropdownOptionWrapper, { onClick: () => handleSelect(option.value, index), children: _jsx(Text, { size: 'Body', children: option.label }) }, `dropdown-option-${option.label}-${index}`));
                            })
                            : children }) }) }) }) }));
}
//# sourceMappingURL=Dropdown.js.map